import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const ExportsQualityCertificationScheme = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Exports Quality Certification Scheme</h1>
          <p className="subtitle">
            The Exports Quality Certification Scheme (EQCS) ensures that Malawi’s agricultural exports meet quality requirements and international standards.
          </p>
          <p className="subtitle">
            EQCS protects consumers, exporters, and the national economy by providing certification for compliant export products.
          </p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="what-section">
        <p className="paragraph">
          The Exports Quality Certification Scheme (EQCS) was established in 1990 with the following objectives:
        </p>
        <ul className="paragraph no-indent">
          <li>To establish base facilities and infrastructure of a National Agricultural Export Quality system;</li>
          <li>To ensure that agricultural exports meet minimum quality requirements for Malawi and importing countries;</li>
          <li>To improve and raise the quality level of agricultural exports;</li>
          <li>To assure exporters that their agricultural exports comply with Malawi Standards and foreign standards requirements.</li>
        </ul>
        <p className="paragraph">
          Through the EQCS, products meant for export are inspected and tested for compliance with the buyers’ specifications. An export certificate is issued for a complying consignment. Agricultural products certified include tobacco, tea, cowpeas, chillies, macadamia nuts, chickpeas, soya beans, sunflower seed and kernels, guar meal, toordhall, hides and skins, peri-peri sauce, cashew nuts, and rice.
        </p>
      </section>

      <br /><br />

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .what-section { padding: 50px 80px; }
        .paragraph {
          font-size: 1rem;
          line-height: 1.7;
          margin: 15px 0;
          text-align: left;
        }

        ul {
          margin: 10px 0;
          padding-left: 0; /* removes indentation */
          list-style-position: inside; /* aligns bullets with paragraph text */
        }

        li {
          margin-bottom: 10px;
        }

        @media screen and (max-width: 768px) {
          .what-section { padding: 25px 20px; }
          .page-title { font-size: 2rem; }
          .overlay { width: 95%; padding: 25px; }
        }
      `}</style>

    </div>
  );
};

export default ExportsQualityCertificationScheme;
